import { QFilterGeneric } from './QFilterGeneric'

export class QFilterPage extends QFilterGeneric {
  name = "page";
  class_name = "QFilterPage";
  api_name = 'offset';
  
  serialize(qfilters) {
    const units_per_page = qfilters.get_filter_value('units_per_page');
    return (units_per_page || 10) * ((this.value || 1) - 1);
  }
}
